import './WebAudioPlayer.scss'

import React from 'react'
import Audio from './Audio'

export default function WebAudioPlayer({
  audioSources,
  musicVolume,
  bgVolume,
  volume,
  duration,
  singleAudio = false
}) {
  return (
    <div>
      <Audio
        audioSources={audioSources}
        musicVolume={musicVolume}
        bgVolume={bgVolume}
        volume={volume}
        soundDuration={duration}
        singleAudio={singleAudio}
      />
    </div>
  )
}
